'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var _require = require('prop-types'),
  func = _require.func;
var ConfigurationFoMarketsService = function ConfigurationFoMarketsService(fileSaveService, momentService, configurationService, restangular, $q, $http, commonUiConstants, advancedGridReloadConfigurationCacheService) {
  var updateBulkFoMarketsService = restangular.service('external').one('faresoptimizer').one('fomarkets').one('bulk');
  function exportToCsv(data) {
    var fileData = createCsvHeader();
    for (var rowId = 0; rowId < data.length; rowId++) {
      fileData += createCsvRow(data[rowId]);
    }
    fileSaveService.createFile(fileData, 'text/csv', 'FOMarkets.csv');
  }
  function createCsvHeader() {
    return formatAsCsvRow(['Host Carrier', 'Tariff Number', 'Tariff Code', 'Origin', 'Destination', 'Point Of Sale', 'Cabin Code', 'Category', 'Benchmark Carriers', 'Host Fare Type Indicator', 'Benchmark Fare Type Indicator', 'Market Tier', 'Fare Change', '% Fare Change - Min', '% Fare Change - Max', 'Check Entry Level Fare Change', 'Adjusted Travel Dates', 'Generate New/Cancel', 'Approved Market', 'Approved Days Of Week', 'Exclusion Reasons', 'Source', 'Market Group', 'Market Type', 'Market Analyst', 'Market Category']);
  }
  function formatAsCsvRow(stringArayToFormat) {
    return stringArayToFormat.join(',') + '\r\n';
  }
  function createCsvRow(row) {
    return formatAsCsvRow([_.isNil(row.hostCarrier) ? '' : row.hostCarrier.toUpperCase(), row.fareTariffNumber, row.fareTariffCode, row.originAirport, row.destinationAirport, row.foPos, row.foCabin, row.marketListCategory, formatCommaSeparatedValue(row.benchmarkCarrier), formatCommaSeparatedValue(row.hostFareTypeIndicator), formatCommaSeparatedValue(row.benchmarkFareTypeIndicator), row.marketTier, row.fareChange, row.minFareChangePercentage, row.maxFareChangePercentage, row.checkEntryLevelFareChange === true, row.adjustedTravelDates === true, row.generateNewCancel === true, row.approvedMarket === true, formatCommaSeparatedValue(row.approvedDaysOfWeek), formatCommaSeparatedValue(row.exclusionReasons), formatCommaSeparatedValue(row.fareSource), formatFreeText(row.marketGroup), formatFreeText(row.marketType), formatFreeText(row.marketAnalyst), formatFreeText(row.marketCategory)]);
  }
  function formatCommaSeparatedValue(value) {
    if (!value) {
      return value;
    }
    var formatted = value.split(',').join('|');
    return '"' + formatted + '"';
  }
  function formatFreeText(value) {
    return value ? '"' + value + '"' : value;
  }
  function remove(rows, gridData, rowIndicesToBeRemoved) {
    var groupedByAction = getDataPartitionedByIndicesPresence(gridData, rowIndicesToBeRemoved);
    var groupedRowsToBeDeleted = getDataGroupedByKey(groupedByAction.rowsToBeRemoved);
    var groupedRowsToBeRetained = getDataGroupedByKey(groupedByAction.rowsToBeRetained);
    var keysToBeDeleted = Object.keys(groupedRowsToBeDeleted);
    var keysToBeRetained = Object.keys(groupedRowsToBeRetained);
    var commonKeys = getCommonKeys(keysToBeRetained, keysToBeDeleted);
    var groupedDataHavingMatchingKeys = getDataForMatchingKeys(groupedRowsToBeRetained, commonKeys);
    var groupedDataHavingNonMatchingKeys = getDataForNonMatchingKeys(groupedRowsToBeDeleted, commonKeys);
    var payloadToBeUpdated = getTransformedMarketListPayload(groupedDataHavingMatchingKeys);
    payloadToBeUpdated = buildFinalPayloads(payloadToBeUpdated);
    var payloadToBeDeleted = getTransformedMarketListPayload(groupedDataHavingNonMatchingKeys);
    payloadToBeDeleted = buildFinalPayloads(payloadToBeDeleted);
    return savePayload(payloadToBeUpdated).then(deleteFromServer(payloadToBeDeleted));
  }
  function getDataPartitionedByIndicesPresence(gridData, rowIndicesToBeRemoved) {
    var rowsToBeRemoved = [];
    var rowsToBeRetained = [];
    _.forEach(gridData, function (value, index) {
      if (_.includes(rowIndicesToBeRemoved, index)) {
        rowsToBeRemoved.push(value);
      } else {
        rowsToBeRetained.push(value);
      }
    });
    return {
      rowsToBeRemoved: rowsToBeRemoved,
      rowsToBeRetained: rowsToBeRetained
    };
  }
  function getDataForMatchingKeys(groupedRowsToBeRetained, keys) {
    var matchingKeyObj = {};
    var allKeys = Object.keys(groupedRowsToBeRetained);
    _.forEach(allKeys, function (key) {
      if (keys.includes(key)) {
        matchingKeyObj[key] = groupedRowsToBeRetained[key];
      }
    });
    return matchingKeyObj;
  }
  function getDataForNonMatchingKeys(groupedRowsToBeDeleted, keys) {
    var nonMatchingKeyObj = {};
    var allKeys = Object.keys(groupedRowsToBeDeleted);
    _.forEach(allKeys, function (key) {
      if (!keys.includes(key)) {
        nonMatchingKeyObj[key] = groupedRowsToBeDeleted[key];
      }
    });
    return nonMatchingKeyObj;
  }
  function deleteFromServer(payloads) {
    var httpContent = _.map(payloads, function (payload) {
      return $http({
        method: 'DELETE',
        url: '/api/external/faresoptimizer/fomarkets',
        data: payload,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      });
    });
    return $q.all(httpContent).then(deleteSuccessCallBack);
  }
  function deleteSuccessCallBack(response) {
    advancedGridReloadConfigurationCacheService.reloadMarkets();
    return response;
  }
  function validate(editedRows, gridData) {
    for (var i = 0; i < editedRows.length; i++) {
      if (hasOneOfTariffCodeOrFareTariffNumberEmpty(editedRows[i])) {
        toastr.error('Any one of Tariff Code or Tariff Number should not be empty for ' + getMarketKey(editedRows[i]));
        return false;
      } else if (hasInvalidOriginDestinationAlphabeticalOrder(editedRows[i])) {
        toastr.error('Origin and destination of Domestic Fare is not in alphabetical order for ' + getMarketKey(editedRows[i]));
        return false;
      }
      if (editedRows[i].fareSource.includes('ATPCO-Cons') && (editedRows[i].fareTariffNumber === undefined || editedRows[i].fareTariffNumber === '' || editedRows[i].fareTariffNumber === null)) {
        toastr.error('Tariff Number should not be empty when faresource contains ATPCO-Cons');
        return false;
      }
      if (editedRows[i].marketListCategory === 'ADAPTIVE' || editedRows[i].marketListCategory === 'MONITOR') {
        editedRows[i].benchmarkCarrier = editedRows[i].hostCarrier;
      }
      if (hasInvalidBenchmarkCarriers(editedRows[i])) {
        toastr.error('Benchmark carrier must be alphanumeric 2 characters and comma separated for multiple carriers for ' + getMarketKey(editedRows[i]));
        return false;
      }
      if (hasInvalidMinMaxFareChangeValues(editedRows[i])) {
        return false;
      }
      if (hasDuplicateEntry(editedRows[i], gridData)) {
        toastr.error('Duplicate/Overlapping rows Identified for ' + getMarketKey(editedRows[i]));
        return false;
      }
      if (hasInvalidProperties(editedRows[i], gridData)) {
        return false;
      }
    }
    return true;
  }
  function hasInvalidBenchmarkCarriers(editedRow) {
    return !!!editedRow.benchmarkCarrier.match(commonUiConstants.COMMA_SEPARATED_CARRIER_CODE_PATTERN);
  }
  function hasOneOfTariffCodeOrFareTariffNumberEmpty(editedRow) {
    var fareTariffCode = editedRow.fareTariffCode;
    var fareTariffNumber = editedRow.fareTariffNumber;
    if (fareTariffNumber === 0) {
      if (!fareTariffCode) {
        return true;
      }
    } else if (!(fareTariffCode && fareTariffNumber) && (fareTariffCode || fareTariffNumber)) {
      return true;
    }
  }
  function tariffCodeAndNumberExist(fareTariffCode, fareTariffNumber) {
    return !isNullOrEmpty(fareTariffCode) && !isNullOrEmpty(fareTariffNumber);
  }
  function bothTariffCodeAndNumberEitherNullOrEmpty(fareTariffCode, fareTariffNumber) {
    return isNullOrEmpty(fareTariffCode) && isNullOrEmpty(fareTariffNumber) || fareTariffCode === undefined || fareTariffNumber === undefined;
  }
  function hasInvalidOriginDestinationAlphabeticalOrder(editedRow) {
    var fareTariffCode = editedRow.fareTariffCode;
    var fareTariffNumber = editedRow.fareTariffNumber;
    if (tariffCodeAndNumberExist(fareTariffCode, fareTariffNumber)) {
      var tariffMatrixProperties = configurationService.getFoFareTariffMatrix();
      if (typeof fareTariffNumber === 'string' || fareTariffNumber instanceof String) {
        fareTariffNumber = parseInt(fareTariffNumber);
      }
      var firstTariffMatrixPropertiesFromSearch = _.find(tariffMatrixProperties, function (tariffMatrixProperty) {
        return tariffMatrixProperty.fareTariffCode === fareTariffCode && parseInt(tariffMatrixProperty.fareTariffNumber) === fareTariffNumber;
      });
      if (firstTariffMatrixPropertiesFromSearch.tariffType === 'Domestic' && editedRow.originAirport > editedRow.destinationAirport) {
        return true;
      }
    }
  }
  function hasInvalidMinMaxFareChangeValues(editedRow) {
    if (isPercentageFareChangePresent(editedRow)) {
      var isValidPercentageFareChange = editedRow.minFareChangePercentage <= editedRow.maxFareChangePercentage;
      if (!isValidPercentageFareChange) {
        toastr.error('Max fare change percentage should be greater than or equal to Min fare change percentage for ' + getMarketKey(editedRow));
        return true;
      }
      return false;
    }
    if (areBothMinAndMaxFareChangePercentageAbsent(editedRow)) {
      return false;
    }
    toastr.error('Both min and max fare change percentage should be integer and present or both should be empty for ' + getMarketKey(editedRow));
    return true;
  }
  function isPercentageFareChangePresent(editedRow) {
    return !isNullOrEmpty(editedRow.minFareChangePercentage) && !isNullOrEmpty(editedRow.maxFareChangePercentage);
  }
  function areBothMinAndMaxFareChangePercentageAbsent(editedRow) {
    return isNullOrEmpty(editedRow.minFareChangePercentage) && isNullOrEmpty(editedRow.maxFareChangePercentage);
  }
  function isNullOrEmpty(field) {
    return _.isNil(field) || field === '';
  }
  function hasDuplicateEntry(newEntry, allRows) {
    var allKeyValues = _.pick(newEntry, ['hostCarrier', 'fareTariffNumber', 'originAirport', 'destinationAirport', 'foCabin', 'marketListCategory']);
    var isMarketDuplicate = false;
    var rowsIdentical = _.chain(allRows).filter(allKeyValues).value();
    rowsIdentical = _.reject(rowsIdentical, newEntry);
    _.forEach(rowsIdentical, function (row) {
      if (hasIntersectingCommaSeparatedProperty(newEntry, row, 'benchmarkCarrier') && hasIntersectingCommaSeparatedProperty(newEntry, row, 'hostFareTypeIndicator') && hasDifferentTarrifNumber(newEntry, row, 'fareTariffNumber')) {
        isMarketDuplicate = true;
      }
    });
    return isMarketDuplicate;
  }
  function hasDifferentTarrifNumber(newEntry, row, field) {
    return newEntry[field] === row[field];
  }
  function hasIntersectingCommaSeparatedProperty(newEntry, row, field) {
    return !!(newEntry[field] && row[field] && _.intersection(newEntry[field].split(','), row[field].split(',')).length > 0);
  }
  function hasInvalidProperties(newEntry, allRows) {
    var allKeyValues = _.pick(newEntry, ['hostCarrier', 'originAirport', 'destinationAirport', 'foCabin', 'marketListCategory']);
    var hasInvalidMarketListEntry = false;
    var rowsIdentical = _.chain(allRows).filter(allKeyValues).value();
    rowsIdentical = _.reject(rowsIdentical, newEntry);
    _.forEach(rowsIdentical, function (row) {
      if (isDifferentHostProperty(newEntry, row, 'marketTier', 'Market Tier')) {
        hasInvalidMarketListEntry = true;
      }
      if (isDifferentHostProperty(newEntry, row, 'generateNewCancel', 'Generate New/Cancel')) {
        hasInvalidMarketListEntry = true;
      }
      if (isDifferentHostProperty(newEntry, row, 'adjustedTravelDates', 'Adjusted Travel Dates')) {
        hasInvalidMarketListEntry = true;
      }
      if (isDifferentHostProperty(newEntry, row, 'checkEntryLevelFareChange', 'Check Entry Level Fare Change')) {
        hasInvalidMarketListEntry = true;
      }
    });
    return hasInvalidMarketListEntry;
  }
  function isDifferentHostProperty(eachRow, row, field, fieldName) {
    if (_.isNil(eachRow[field]) && _.isNil(row[field]) || !_.isNil(eachRow[field]) && _.isEmpty(eachRow[field].toString()) && _.isNil(row[field]) || !_.isNil(row[field]) && _.isEmpty(row[field].toString()) && _.isNil(eachRow[field])) {
      return false;
    }
    if (!_.isNil(eachRow[field]) && !_.isNil(row[field]) && eachRow[field].valueOf().toString() === row[field].valueOf().toString()) {
      return false;
    }
    toastr.error(fieldName + ' should be same for same HostCarrier-Market-Cabin-Category for ' + getMarketKey(eachRow));
    return true;
  }
  function save(editedRows, gridData) {
    var payloads = buildSavePayloads(editedRows, gridData);
    return savePayload(payloads);
  }
  function buildSavePayloads(rows, gridData) {
    var unchangedGridData = getUnchangedData(gridData);
    transformFOMarketsColumns(rows);
    var groups = getMergedData(rows, unchangedGridData);
    var transformedMarketListPayload = getTransformedMarketListPayload(groups);
    _.forEach(rows, function (row) {
      if (row.marketListCategory === 'ADAPTIVE') {
        row.benchmarkCarrier = row.hostCarrier;
      }
    });
    return buildFinalPayloads(transformedMarketListPayload);
  }
  function transformFOMarketsColumns(rows) {
    rows.forEach(function (row) {
      if (row.marketGroup) {
        row.marketGroup = row.marketGroup.toUpperCase();
      }
      if (row.marketType) {
        row.marketType = row.marketType.toUpperCase();
      }
      if (row.marketAnalyst) {
        row.marketAnalyst = row.marketAnalyst.toUpperCase();
      }
      if (row.marketCategory) {
        row.marketCategory = row.marketCategory.toUpperCase();
      }
    });
  }
  function buildFinalPayloads(rows) {
    return _.reduce(rows, function (result, row) {
      result.push(buildPayload(row));
      return result;
    }, []);
  }
  function buildPayload(row) {
    return {
      hostCarrier: getStringValue(row.hostCarrier),
      fareTariffCode: row.fareTariffCode,
      fareTariffNumber: row.fareTariffNumber,
      origin: row.originAirport.toUpperCase(),
      destination: row.destinationAirport.toUpperCase(),
      cabinCode: row.foCabin,
      category: row.marketListCategory,
      pos: row.foPos,
      benchmarkCarrier: row.benchmarkCarrier,
      benchmarkDetails: row.benchmarkDetails,
      marketTier: row.marketTier,
      fareChange: row.fareChange,
      minFareChangePercentage: row.minFareChangePercentage,
      maxFareChangePercentage: row.maxFareChangePercentage,
      checkEntryLevelFareChange: row.checkEntryLevelFareChange,
      approvedMarket: row.approvedMarket,
      approvedDaysOfWeek: row.approvedDaysOfWeek,
      exclusionReasons: row.exclusionReasons,
      hostFareTypeIndicator: row.hostFareTypeIndicator,
      benchmarkFareTypeIndicator: row.benchmarkFareTypeIndicator,
      fareSource: row.fareSource,
      adjustedTravelDates: row.adjustedTravelDates,
      generateNewCancel: row.generateNewCancel,
      marketGroup: row.marketGroup,
      marketType: row.marketType,
      marketAnalyst: row.marketAnalyst,
      marketCategory: row.marketCategory
    };
  }
  function getUnchangedData(gridData) {
    return _.chain(gridData).filter(function (data) {
      return _.isUndefined(data._old);
    }).value();
  }
  function getMergedData(payload, gridData) {
    var payloadGroups = getDataGroupedByKey(payload);
    var gridDataGroups = getDataGroupedByKey(gridData);
    var payloadKeys = Object.keys(payloadGroups);
    var gridDataKeys = Object.keys(gridDataGroups);
    var commonKeys = getCommonKeys(payloadKeys, gridDataKeys);
    commonKeys.forEach(function (key) {
      payloadGroups[key] = payloadGroups[key].concat(gridDataGroups[key]);
    });
    return payloadGroups;
  }
  function getTransformedMarketListPayload(groups) {
    return _.chain(_.values(groups)).transform(function (result, markets) {
      markets[0].benchmarkDetails = getBenchmarkDetails(markets);
      result.push(markets[0]);
    }, []).value();
  }
  function getBenchmarkDetails(markets) {
    return _.chain(markets).map(function (market) {
      return {
        benchmarkCarrier: market.benchmarkCarrier.toUpperCase().replace(/^\s*|\s*$/g, '').split(/\s*,\s*/),
        hostFareTypeIndicator: market.hostFareTypeIndicator,
        benchmarkFareTypeIndicator: market.benchmarkFareTypeIndicator,
        approvedDaysOfWeek: market.approvedDaysOfWeek,
        exclusionReasons: market.exclusionReasons,
        fareSource: market.fareSource,
        approvedMarket: market.approvedMarket
      };
    }).value();
  }
  function savePayload(payloads) {
    var promises = [];
    if (payloads && payloads.length) {
      promises.push(saveToServer(payloads));
    }
    return $q.all(promises);
  }
  function saveToServer(payloads) {
    return updateBulkFoMarketsService.customPUT({
      value: payloads
    });
  }
  function getStringValue(value) {
    return _.isNil(value) || _.isEmpty(value) ? null : value;
  }
  function getCommonKeys(payloadKeys, gridDataKeys) {
    return gridDataKeys.filter(function (gridDataKey) {
      return payloadKeys.includes(gridDataKey);
    });
  }
  function getDataGroupedByKey(data) {
    return _.groupBy(data, function (row) {
      return getMarketKey(row);
    });
  }
  function getMarketKey(row) {
    return [row.hostCarrier, row.fareTariffNumber, row.originAirport, row.destinationAirport, row.foCabin, row.marketListCategory].join('-');
  }
  return {
    exportToCsv: exportToCsv,
    remove: remove,
    validate: validate,
    save: save
  };
};
ConfigurationFoMarketsService.$inject = ['FileSaveService', 'MomentService', 'ConfigurationService', 'Restangular', '$q', '$http', 'CommonUiConstants', 'AdvancedGridReloadConfigurationCacheService'];
module.exports = ConfigurationFoMarketsService;